import axios from 'axios'
import store from '../store'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchTaxTableData({ state }, { stateId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.gettaxesbystate
        }/${stateId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveTaxTableData(
    { state },
    {
      stateId,
      taxType,
      taxAuthorityId,
      description,
      rate,
      parentId,
      taxAuthorityName,
    } = {}
  ) {
    var taxData = {}
    taxData.StateId = stateId
    taxData.TaxType = taxType
    taxData.TaxAuthorityId = taxAuthorityId === '' ? 0 : taxAuthorityId
    taxData.Description = description
    taxData.Rate = rate
    taxData.ParentId = parentId === '' ? 0 : parentId
    taxData.TaxAuthorityName = taxAuthorityName
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.createtaxdetails}`,
        taxData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  updateTaxTableData(
    { state },
    {
      taxId,
      stateId,
      taxType,
      taxAuthorityId,
      description,
      rate,
      parentId,
      taxAuthorityName,
    } = {}
  ) {
    var taxData = {}
    taxData.TaxId = taxId
    taxData.StateId = stateId
    taxData.TaxType = taxType
    taxData.TaxAuthorityId = taxAuthorityId === '' ? 0 : taxAuthorityId
    taxData.Description = description
    taxData.Rate = rate
    taxData.ParentId = parentId === '' ? 0 : parentId
    taxData.TaxAuthorityName = taxAuthorityName
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updatetaxdetails}`,
        taxData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  deleteTaxTableData({ state }, { taxId } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.adminApiPath.deletetaxdetails
        }/${taxId}`,
        {}, 
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
